module.exports = __webpack_public_path__ + "videos/selection_cn.25fa8c6.mp4";